import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { SendingTimeHeroSection } from "@/components/insights/sending-time/SendingTimeHeroSection";
import { SendingTimeKeyFindings } from "@/components/insights/sending-time/SendingTimeKeyFindings";
import { SendingTimePatternAnalysis } from "@/components/insights/sending-time/SendingTimePatternAnalysis";
import { SendingTimeBestPractices } from "@/components/insights/sending-time/SendingTimeBestPractices";
import { SendingTimeTakeaway } from "@/components/insights/sending-time/SendingTimeTakeaway";
import { SendingTimeFounderQuote } from "@/components/insights/sending-time/SendingTimeFounderQuote";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { InsightFAQSection } from "@/components/InsightFAQSection";
import { InsightBenchmarks } from "@/components/InsightBenchmarks";
import { TableOfContents } from "@/components/TableOfContents";

const SendingTimeSpamFilters = () => {
  return (
    <>
      <InsightEngagementTracker slug="sending-time-spam-filters" title="Sending Time & Spam Filters" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb 
          category="Deliverability" 
          currentPage="Sending Time & Spam Filters" 
        />
        <SendingTimeHeroSection />
        
        <AnimatedSection delay={100} className="mt-10 sm:mt-12">
          <SendingTimeTakeaway />
        </AnimatedSection>

        <AnimatedSection delay={50} className="mt-8 sm:mt-10">
          <SendingTimeFounderQuote />
        </AnimatedSection>

        <div className="section-divider" />

        <AnimatedSection delay={0}>
          <SendingTimeKeyFindings />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <SendingTimePatternAnalysis />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <SendingTimeBestPractices />
        </AnimatedSection>
        
        {/* Benchmark Tables */}
        <AnimatedSection delay={0}>
          <InsightBenchmarks insightSlug="sending-time-spam-filters" />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <InsightFAQSection insightSlug="sending-time-spam-filters" />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <RelatedTools insightSlug="sending-time-spam-filters" />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default SendingTimeSpamFilters;
